import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Unique Tandukar</span>{" "}
            from <span className="purple">Chabahil, Kathmandu</span>.
            <br />
            I've completed BSc. CSIT from St. Lawrence College,
            Chuchchepati, with a focus on{" "}
            <span className="purple">Quality Assurance</span> and{" "}
            <span className="purple">Project Management</span>.
            <br />
            <br />
            Apart from testing and managing projects, here are a few other
            things I love doing!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Exploring Testing Tools
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Quality is not an act, it's a habit!"
          </p>
          <footer className="blockquote-footer">Unique Tandukar</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;